// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__1nu7s","additionalInfo":"AgreementModal_additionalInfo__1t2Kc"};